<template>

<div class="content" @change="formDirty=true">
    <div class="container-fluid">
        <div class="row">
            <div class="col-xl-12">
                <div v-if="loading">
                    <h4>Loading...</h4>
                </div>
                <div v-else>
                    <h4 class="card-title">Vendor {{this.vendorId}}: {{this.vendorData['supplier']}}
                    <br/>Contract: {{this.vendorData['contract_name']}}</h4>
                    <div class="col-xl-8">
                        <b-row>
                            <b-col>
                                <hr>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>Current Contract:</b-col>
                        </b-row>
                        <b-row>
                            <b-col>Starting Date: {{this.vendorData['starts'].toLocaleString("de-AT").split(',')[0]}} </b-col>
                            <b-col>Expiration Date: {{this.vendorData['expires'].toLocaleString("de-AT").split(',')[0]}}</b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <hr>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>Renewal Process:
                                <b-button variant="primary"  v-on:click="startRenewal">Start Renewal Process </b-button>
                                <b-button v-if="formDirty && renewal_id != null" :disabled="saving || renewal_id == null" variant="success" v-on:click="saveRenewal">Save Changes</b-button>
                                <b-button v-else :disabled="saving || !start_renewal" variant="primary" v-on:click="saveRenewal">Save Changes</b-button>
                                <b-button v-if="renewal_id !== null" variant="primary" v-on:click="exportRenewal">Export to csv</b-button>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <hr>
                            </b-col>
                        </b-row>
                        <b-row>
                        </b-row>
                        <div v-if="this.start_renewal || this.renewal_id">
                            <b-row>
                                <b-col>Current Renewal Process:</b-col>
                            </b-row>
                            <b-row>
                                <b-col style='max-width:130px;'>
                                    Starting Date:</b-col>
                                <b-col style='max-width:150px'>
                                    {{displayDate(selectedDate)}}
                                    <vc-date-picker
                                    @input="formDirty=true"
                                    v-model="selectedDate"
                                    is-expanded=false
                                    :popover="{ placement: 'bottom', visibility: 'click' }">
                                        <button class="rounded focus:outline-none fill-current">>
                                        </button>
                                    </vc-date-picker>


                                </b-col>
                                <b-col style='max-width:130px;'>
                                    Due Date:</b-col>
                                <b-col style='max-width:150px'>
                                    {{this.due_date.toLocaleString("de-AT").split(',')[0]}}
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col>
                                    Duration: {{this.totalDuration}} days
                                </b-col>
                                <b-col>Status:
                                    <select v-model="status">
                                        <option selected>Draft</option>
                                        <option>In Progress</option>
                                        <option>Finished</option>
                                        <option>Canceled</option>
                                    </select>
                                </b-col>
                            </b-row>
                        </div>
                    </div>
                    <div >
                        <b-tabs content-class="mt-3">
                            <b-tab  title="Personas" active>
                                <enhanced-table
                                nosearch=true
                                :hideFields="['renewal_id']"
                                style='min-width:100px'
                                id='renewal_id'
                                @remove-item='removePersona'
                                :datalist="renewalPersonas" />

                                <button v-if="!addingPersona" v-on:click="addingPersona=true">Add Persona</button>

                                <select v-model="selectedRole" v-if="addingPersona" name="selectedRole" id="selectRole">
                                   <option value="Procurement">Procurement</option>
                                   <option value="Stakeholder">Stakeholder</option>
                                   <option value="Legal">Legal</option>
                                </select>
                                <select v-model="selectedUser" v-if="addingPersona" name="selectedUser" id="selectUser">
                                   <option :value="email" v-for="(name, email) in userList">
                                        {{name}}
                                    </option>
                                </select>
                                <button v-if="addingPersona"
                                     v-on:click="addPersona">Add Persona</button>
                                <button v-if="addingPersona"
                                     v-on:click="addingPersona=false">Cancel</button>
                            </b-tab>

                            <b-tab title="Tasks" v-if="this.renewal_id != null">
                                <gantt
                                    rw
                                    class="tasks-container"
                                    :key='refreshGantt'
                                    :tasks="tasks"
                                    :isAdmin="userAdmin"
                                    :userInfo="userInfo"
                                    @task-selected='taskSelected'
                                    @tasks-updated="tasksUpdated"
                                    @task-progress-changed="taskProgressChanged"
                                    :userDict="validUserDict" />
                                <enhanced-table :key='refreshAnnotations' nosearch=true :hideFields="['userEmail']" style='min-width:400px' id='taskAnnotation' :datalist="annotations" />
                                <textarea style='width:600px' v-model="newAnnotation" placeholder="task annotation" />
                                <br /><button :disabled="!(currentTask > -1 && newAnnotation.length > 0)" v-on:click="addAnnotation">Add Annotation</button>
                            </b-tab>
                            <b-tab title="Renewal Log" v-if="this.renewal_id != null">
                                <enhanced-table id='log' :hideFields="['userEmail']" @remove-item='removeItem' @edit-item='editItem' :datalist="renewal_log" />
                                <div>
                                    {{displayDate(logDate)}}
                                    <vc-date-picker
                                    class="datePicker"
                                    v-model="logDate"
                                    :popover="{ placement: 'bottom', visibility: 'click' }">
                                        <button class="rounded focus:outline-none fill-current">>
                                        </button>
                                    </vc-date-picker>
                                    <textarea style='width:500px; height:30px; vertical-align:middle;' v-model="logText" placeholder="log annotation" />
                                <button :disabled="!logText" v-on:click="addManualLog">Add Entry</button>
                                </div>
                            </b-tab>
                        </b-tabs>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import ChartCard from 'src/components/Cards/ChartCard.vue'
import StatsCard from 'src/components/Cards/StatsCard.vue'
import LTable from 'src/components/Table.vue'
import axios from 'axios'
import {
    colors,
    formatMoney,
    formatSimple
} from 'src/globalVariables'
import {
    setInterval
} from 'timers';
import Gantt from 'src/components/gantt.vue';
import {
    uuid
} from 'vue-uuid';

Number.prototype.pad = function (size) {
    let s = String(this);
    while (s.length < (size || 2)) {
        s = "0" + s;
    }
    return s;
}

export default {
    components: {
        LTable,
        ChartCard,
        StatsCard,
        Gantt
    },

    props: ['vendorId'],
    watch: {
        renewalPersonas: function(){
            var vm = this
            this.validUserDict = {}
            this.renewalPersonas.forEach(function(v){
                vm.validUserDict[v['user_email']] = v['user_name']
            })
            this.refreshGantt++
        },
        vendorData: function () {
            this.vendorData['starts'] = new Date(this.vendorData['starts'])
            this.vendorData['expires'] = new Date(this.vendorData['expires'])
            if (this.vendorData['renewal_id'] != null) {
                this.renewal_id = this.vendorData['renewal_id']
                this.selectedDate = new Date(this.vendorData['starting_date'])
                this.status = this.vendorData['status']
                this.due_date = new Date(this.vendorData['due_date']).toISOString().split('T')[0];
                this.tasks = JSON.parse(this.vendorData['tasks_details'])
                this.renewal_log = JSON.parse(this.vendorData['renewal_log'])
            }

        },
        status: function () {
            // adds a log entry every time the status is changed
            if (!this.loading) {
                this.logDate = new Date().toISOString()
                this.logText = 'Status changed to ' + this.status
                this.addLog()
            }
        },
        selectedDate: function (dt) {
            dt = (new Date(dt - this.tzoffset)).toISOString();
            this.vendorData['starting_date'] = dt.split('T')[0]
            this.calculateDates()
            this.logDate = new Date().toISOString()
            this.logText = 'Starting date changed to ' + new Date(dt).toLocaleString('de-AT').split(',')[0]
            this.addLog()
        }
    },
    async created() {
        this.accessToken = await this.$auth.getAccessToken()
        this.loadData();
        this.loadUserInfo();
    },

    methods: {
        displayDate(dt){
            return new Date(dt).toLocaleDateString('de-DE')

        },
        async loadUserInfo() {
            this.userInfo = Object.assign({}, await this.$auth.getUser())
            // check if user is a global admin
            axios
                .get('/user/isAdmin/' + this.userInfo.email + '?access_token=' + this.accessToken, )
                .then((response) => {
                    this.userAdmin = response.data
                });

        },
        removePersona(persona){
            let newPersonas = []
            this.renewalPersonas.forEach(function(p){
                if (!(persona.user_email == p.user_email && persona.role_name == p.role_name))
                    newPersonas.push(p)
            })
            if (this.renewalPersonas != newPersonas){
                this.formDirty = true
            }
            this.renewalPersonas = newPersonas
        },
        findPersona(role){
            var user = ''
            this.renewalPersonas.some(function(v){
                if (v['role_name'] == role){
                    user = v['user_email']
                    return
                }
            })
            return user
        },
        checkPersonas(){
            // check if all the needed personas are in place
            if (this.findPersona('Procurement')!='' &&
                this.findPersona('Legal')!='' &&
                this.findPersona('Stakeholder')!=''){
                    return true
                }
            return false
        },
        startRenewal() {
            var startRenewal = true
            if (!this.checkPersonas()){
                window.alert('Please add at least one persona of each role before starting a new renewal process!')
            }
            else{
                if (this.renewal_id != null) {
                    const answer = window.confirm('Do you really start over? Any changes will be discarded.')
                    if (!answer) {
                        startRenewal = false
                    }
                }
                if (startRenewal) {
                    axios
                    .get('/renewal-template' + '?access_token=' + this.accessToken)
                    .then((response) => {
                        this.renewalTemplate = response.data
                        this.status = 'Draft'
                        this.vendorData['starting_date'] = new Date()
                        this.tasks = this.renewalTemplate
                        let vm = this
                        this.tasks.data.forEach(function (v) {
                            // finds the first user for the designed role
                            v.assignee = vm.findPersona(v['assignee'])
                        })
                        this.selectedDate = this.vendorData['starting_date'];
                        this.start_renewal = true;
                    });
                }
            }

        },
        saveRenewal() {
            this.saving = true
            var renewalData = new FormData()
            renewalData.append('contract_number', this.vendorId)
            renewalData.append('renewal_id', this.renewal_id)
            renewalData.append('starting_date', this.vendorData['starting_date'].toISOString())
            renewalData.append('due_date', this.due_date.toISOString())
            renewalData.append('status', this.status)
            renewalData.append('tasks_details', JSON.stringify(this.tasks))
            renewalData.append('renewal_log', JSON.stringify(this.renewal_log))
            renewalData.append('access_token', this.accessToken)
            var renewalPersonas = new FormData()
            renewalPersonas.append('access_token', this.accessToken)
            renewalPersonas.append('renewal_personas', JSON.stringify(this.renewalPersonas))
            axios
                .post('/vendor/' + this.vendorId, renewalData, {
                    headers: {
                        'Content-Type': 'application/json',
                    }
                })
                .then((response) => {
                    this.renewal_id = response.data.renewal_id;
                    axios
                        .post('/renewal-personas/'+ this.renewal_id, renewalPersonas, {
                            headers: {
                                'Content-Type': 'application/json',
                            }
                        })
                        .then((response) => {

                            if (response.status == 200) {
                                this.formDirty = false
                                window.alert('Contract saved sucessfully.')
                                this.$router.push({ path: '/views/vendors' })

                            }
                            this.saving = false
                        }, (error) => {
                            console.log(error)
                            window.alert('Error saving contract.')
                            this.saving = false
                        });
                }, (error) => {
                    console.log(error)
                    window.alert('Error saving contract.')
                    this.saving = false
                });
        },
		exportRenewal() {
			axios.get('/renewal-export/' + this.renewal_id + '?access_token=' + this.accessToken)
				.then(response => {
					let url = window.URL.createObjectURL(new Blob([response.data]));
					let link = document.createElement('a');
					link.href = url;
					let fileName = this.renewal_id + '.csv';
					link.setAttribute('download', fileName);
					document.body.appendChild(link);
					link.click();
					link.remove();
				})
		},
        editItem(it) {},
        removeItem(it) {
            // removes the requested item from renewal_log (takes care of filtered or sorted list)
            var index = -1
            this.renewal_log.some(function (v, i) {
                if (v['date'] == it['date'] && v['entry'] == it['entry'])
                    index = i
                return
            })
            if (index >= 0) {
                this.renewal_log.splice(index, 1)
            }
        },
        addManualLog() {
            this.logDate = new Date(new Date(this.logDate) - this.tzoffset)
            this.addLog()
        },
        addLog() {
            if (!this.loading) {
                this.renewal_log.push({
                    'date': new Date(this.logDate),
                    'userEmail': this.userInfo.email,
                    'user': this.userInfo.name,
                    'entry': this.logText,
                    'action1': 'Remove',
                    'action2': 'Edit'
                })
            }
            this.logText = ''
        },
        addPersona(){
            var found = false
            var vm = this
            this.renewalPersonas.some(function(v){
                if (v['role_name'] == vm.selectedRole && v['user_email'] == vm.selectedUser){
                    found = true
                }
            })
            if (!found){
                this.renewalPersonas.push({'renewal_id': this.renewal_id,'role_name': this.selectedRole, 'user_email': this.selectedUser, 'user_name':this.userList[this.selectedUser], 'action1':'Remove'  })
                this.formDirty = true
                this.logDate = new Date().toISOString()
                this.logText = this.selectedUser+' added.'
                this.addLog()

            }
            this.addingPersona = false
        },
        addAnnotation() {
            this.tasks.data[this.currentTask - 1].annotation.push({
                'date': new Date(),
                'userEmail': this.userInfo.email,
                'user': this.userInfo.name,
                'text': this.newAnnotation
            })
            this.annotations = this.tasks.data[this.currentTask - 1].annotation
            this.newAnnotation = ''
            this.refreshGantt++
        },
        taskSelected(task) {
            this.annotations = task.annotation
            this.currentTask = task.id
        },
        tasksUpdated(tasks) {
            this.formDirty = true
            this.tasks = Object.assign({}, tasks);
            this.tasks.data.forEach(function (v) {
                delete v['end_date'] // this field comes back from the component, we have to remove otherwise recalculations will fail
            })
            this.calculateDates()
        },
        taskProgressChanged(changedTask, tasks) {
            this.taskSelected(changedTask)
            this.tasksUpdated(tasks);
            this.newAnnotation = 'progress changed to ' + Math.round(changedTask.progress * 100) + ' %'
            this.addAnnotation()
        },
        calculateDates() {
            // adjust dates for the tasks, based on the duration
            var vm = this
            this.vendorData['starting_date'] = new Date(this.vendorData['starting_date'])
            var curDate = null;
            var lastDuration = 0;
            this.totalDuration = 0;
            this.tasks.data.forEach(function (v, i) {
                if (i == 0) {
                    curDate = new Date(vm.vendorData['starting_date']);
                } else {

                    if (!v['parallel']) {
                        curDate.setDate(curDate.getDate() + lastDuration);
                    }
                }
                lastDuration = v['duration']
                var textDate = curDate.toISOString()
                v['start_date'] = textDate;
                vm.totalDuration += v['duration']
                vm.due_date = new Date(curDate.toISOString())
                vm.due_date.setDate(vm.due_date.getDate() + v['duration'])
                // vm.due_date = vm.due_date.toLocaleString("de-AT").split(',')[0];
            })

            this.refreshGantt++

        },
        logTaskUpdate(t) {},
        loadData() {
            let today = new Date();
            let vm = this;
            this.last_update = today.getHours().pad(2) + ":" + today.getMinutes().pad(2) + ":" + today.getSeconds().pad(2);
            axios
                .get('/vendor/' + vm.vendorId + '?access_token=' + this.accessToken)
                .then((response) => {
                    this.vendorData = response.data
                    axios
                    .get('/renewal-personas/'+ this.vendorData['renewal_id'] + '?access_token=' + this.accessToken)
                    .then((response) => {
                        this.renewalPersonas = response.data
                        this.renewalPersonas.forEach(function(persona){
                            persona.action1='Remove'
                        })
                        this.$nextTick(function () {
                            this.loading = false
                        })

                    });
                });
            axios
                .get('/renewal-template' + '?access_token=' + this.accessToken)
                .then(response => (
                    this.renewalTemplate = response.data
                ));
            axios
                .get('/user/list?access_token=' + this.accessToken)
                .then((response) => {
                    this.userList = {};
                    response.data.forEach(function (v) {
                        vm.userList[v['email']] = v['name']
                    })
                });

        },
    },
    data() {
        return {
            validUserDict:{},
            selectedRole: '',
            seletedUser:'',
            userList:[],
            userListHTML:'',
            addingPersona: false,
            accessToken: '',
            totalDuration: 0,
            tzoffset: (new Date()).getTimezoneOffset() * 60000, //offset in milliseconds
            saving: false,
            renewalTemplate: {},
            renewalPersonas:[],
            vendorData: {},
            renewal_id: null,
            selectedDate: '',
            due_date: '',
            status: 'Draft',
            tasks: {},
            renewal_log: [],
            userInfo: {},
            loading: true,
            initialDate: null,
            refreshGantt: 0,
            tasks_details: [],
            renderGantt: false,
            logDate: new Date(),
            logText: '',
            annotations: [],
            currentTask: -1,
            isTaskSelected: false,
            newAnnotation: '',
            refreshAnnotations: 0,
            formDirty: false,
            userAdmin: false,
            start_renewal: false,
        }
    },
    beforeRouteLeave(to, from, next) {
        if (this.formDirty) {
            const answer = window.confirm('Do you really want to leave? you are in the middle of an update!')
            if (answer) {
                next()
            } else {
                next(false)
            }
        } else {
            next()
        }
    }
}
</script>

<style>
.datePicker.input {

  width: 150px;
  height: 38px;
}
h4.btn {
    background-color: #343a40;
    border-color: #343a40;
    color: #FFFFFF;
}

span.nav-link {
    cursor: pointer;
}

html,
body {
    height: 100%;
    margin: 0;
    padding: 0;
}

.container {
    height: 100%;
    width: 100%;
}

.tasks-container {
    overflow: hidden;
    position: relative;
    height: 400px;
}

.bottom-container {
    border-right: 1px solid #cecece;
    font-family: Geneva, Arial, Helvetica, sans-serif;
    height: 20%;
    box-shadow: 0 0 5px 2px #aaa;
    position: relative;
}

.gantt-messages {
    list-style-type: none;
    height: 10%;
    margin: 0;
    overflow-x: hidden;
    overflow-y: auto;
    padding-left: 5px;
}

.gantt-messages>.gantt-message {
    background-color: #f4f4f4;
    box-shadow: inset 5px 0 #d69000;
    font-family: Geneva, Arial, Helvetica, sans-serif;
    font-size: 14px;
    margin: 5px 0;
    padding: 8px 0 8px 10px;
}

.gantt-selected-info {
    border-bottom: 1px solid #cecece;
    box-sizing: border-box;
    font-family: Geneva, Arial, Helvetica, sans-serif;
    height: 50%;
    line-height: 28px;
    padding: 10px;
}

.gantt-selected-info h2 {
    border-bottom: 1px solid #cecece;
}

.select-task-prompt h2 {
    color: #d9d9d9;
}

.colorized {
    background-color: red !important;
    opacity: 1;
}
</style>
